"use client";

import { useIntersectionObserverAPI } from "@trydig/ui/hooks";

export const Sentinel = ({ action }: { action: () => void }) => {
	const obserrver = useIntersectionObserverAPI(([entry]) => {
		if (entry?.isIntersecting) {
			action();
		}
	});

	return (
		<span
			ref={(element) => {
				obserrver?.observe(element!);
				return () => {
					obserrver?.disconnect();
				};
			}}
		/>
	);
};
